import InnerPrinterReceipt from './InnerPrinterReceipt';
import InnerPrinterOrderHistoryReceipt from './InnerPrinterOrderHistoryReceipt';

export default {
  InnerPrinterReceipt,
  InnerPrinterOrderHistoryReceipt,
};
